export default __webpack_public_path__ + "0b48e4a098838cee07a2cac2ba43ad94.jpg";